import { FacebookModalStateTypes } from "@enums/digital-audience/FacebookModalStateTypes";
import { DigitalAudienceAccountsActions, DigitalAudienceAccountsActionsType } from "./DigitalAudienceAccountsActions";
import { AdAccountMatching } from "@appTypes/digital-audience/DigitalAudience";

export type DigitalAudienceAccountsState = {
  isAccountsModalOpened: boolean;
  isLoading: boolean;
  facebook: DigitalAudienceAccountsFacebookState;
};

export type DigitalAudienceAccountsFacebookState = {
  userToken: any;
  userName: string | null;
  isLoggedIn: boolean;
  currentState: FacebookModalStateTypes;
  isEverythingOnboarded: boolean;
  adAccountMatchingList: AdAccountMatching[];
  isOnboardingSaveBlocked: boolean;
  acceptedTerms: {key: string, value: boolean}[];
};

const digitalAudienceAccountsState = (): DigitalAudienceAccountsState => ({
  isAccountsModalOpened: false,
  isLoading: false,
  facebook: digitalAudienceFacebookInitState()
});

const digitalAudienceFacebookInitState = (): DigitalAudienceAccountsFacebookState => ({
  userToken: null,
  userName: null,
  isLoggedIn: false,
  currentState: FacebookModalStateTypes.FbLoginState,
  isEverythingOnboarded: false,
  adAccountMatchingList: [],
  isOnboardingSaveBlocked: false,
  acceptedTerms: []  
});

export const digitalAudienceAccountsReducer = (
  state: DigitalAudienceAccountsState = digitalAudienceAccountsState(),
  action: DigitalAudienceAccountsActions
): DigitalAudienceAccountsState => {

  switch (action.type) {
    case DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_OPENED: {
      return {
        ...state,
        isAccountsModalOpened: action.payload.isOpened
      }
    }

    case DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_ISLOADING: {
      return {
        ...state,
        isLoading: action.payload.isLoading
      }
    }

    case DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_USERTOKEN: {
      return {
        ...state,
        facebook: {
          ...state.facebook,
          userToken: action.payload.userToken
        }
      }
    }

    case DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_USERNAME: {
      return {
        ...state,
        facebook: {
          ...state.facebook,
          userName: action.payload.userName
        }
      }
    }

    case DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ISLOGGEDIN: {
      return {
        ...state,
        facebook: {
          ...state.facebook,
          isLoggedIn: action.payload.isLoggedIn
        }
      }
    }

    case DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_CURRENTSTATE: {
      return {
        ...state,
        facebook: {
          ...state.facebook,
          currentState: action.payload.currentState
        }
      }
    }

    case DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ISEVERYTHINGONBOARDED: {
      return {
        ...state,
        facebook: {
          ...state.facebook,
          isEverythingOnboarded: action.payload.isEverythingOnboarded
        }
      }
    }

    case DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ADACCOUNTMATCHINGLIST: {
      return {
        ...state,
        facebook: {
          ...state.facebook,
          adAccountMatchingList: action.payload.adAccountMatchingList
        }
      }
    }

    case DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ISONBOARDINGSAVEBLOCKED: {
      return {
        ...state,
        facebook: {
          ...state.facebook,
          isOnboardingSaveBlocked: action.payload.isOnboardingSaveBlocked
        }
      }
    }

    case DigitalAudienceAccountsActionsType.SET_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ADACCOUNTACCEPTEDTERMS: {
      return {
        ...state,
        facebook: {
          ...state.facebook,
          acceptedTerms: action.payload.acceptedTerms
        }
      }
    }

    case DigitalAudienceAccountsActionsType.TOGGLE_DIGITAL_AUDIENCE_ACCOUNT_MODAL_FACEBOOK_ADACCOUNTTERMCHECKED: {
      return {
        ...state,
        facebook: {
          ...state.facebook,
          adAccountMatchingList: state.facebook.adAccountMatchingList.map((item) =>
            item.adAccount.id === action.payload.adAccountId
              ? { ...item, areTermsAccepted: !item.areTermsAccepted }
              : item
          ),
        }
      }
    }    

    case DigitalAudienceAccountsActionsType.RESET_DIGITAL_AUDIENCE_FACEBOOK_STATE: {
      return {
        ...state,
        facebook: digitalAudienceFacebookInitState()
      }
    }    
    
    default:
      return state;
  }
};